import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { nanoid } from '@reduxjs/toolkit';
//import { fetchPosts } from '../actions/postsActions';
//import { Post } from '../components/Post';
import {
    Progress,
    Text,
    Grid,
    createStyles,
} from '@mantine/core';
import { useSelector } from 'react-redux';
import { FooterSimple } from '../components/FooterSimple';
import { MobileSimpleHeader } from '../components/MobileSimpleHeader';
import { DocsFilter } from '../components/DocsFilter';
import DocsItem from '../components/DocsItem';

import pagani from '../assets/pagani.jpg';
const useStyles = createStyles((theme) => ({
    docsGrid: {
        maxWidth: '800px',
        margin: '0 auto'
    }
}));

//this needs params
const MsgsPage = () => {
    const { classes, theme } = useStyles();
    return (
        <>
        {/*
            <MobileSimpleHeader 
                avatar={pagani}
                drawSubSectMenu={false}
            />
            have a switch case for assignment of the sub menu*/}
            <br/>
            <br/>
            <DocsFilter className={classes.docsGrid}/>
            <br/>
            <br/>
            <Grid justify="center" align="center" gutterXl="xl" className={classes.docsGrid}>
                <Grid.Col span={4}>
                    <DocsItem category_title="Getting Started"/>
                </Grid.Col>
                <Grid.Col span={4}>
                    <DocsItem category_title="Tips And Tricks" />
                </Grid.Col>
                <Grid.Col span={4}>
                    <DocsItem  category_title="Templates"/>
                </Grid.Col>
                <Grid.Col span={4}>
                    <DocsItem category_title="Third Party Services"/>
                </Grid.Col>
                <Grid.Col span={4}>
                    <DocsItem  category_title="Payment Services"/>
                </Grid.Col>
                <Grid.Col span={4}>
                    <DocsItem  category_title="Account Management"/>
                </Grid.Col>
            </Grid>

            <br/>
            <br/>
            <br/>
            <br/>
            <FooterSimple />
        </>
    )

}

export default MsgsPage
